// extracted by mini-css-extract-plugin
module.exports = {"container":"_99551c8aa8--container--HYkki","child":"_99551c8aa8--child--PdfOw"};